// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FreePlanModal_wrapper__3sDgL"};